export default __webpack_public_path__ + "expand-globally.74fc0eac.svg";